"use strict";

/**
* Реквизит типа «Ссылка на документ» для детальных разделов.
* 
* @class WebAccess.components.wrappers.form.requisites._details.Document
* @extends WebAccess.components.wrappers.form.requisites.Document
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @private
*/
(function (global) {

  const Document = global.Document.extend([global._details.editModeMixin], {
    className: 'DetailDocument'
  });

  global._details.Document = Document;
})(window.WA.CMP.wrappers.form.requisites);